import * as React from "react";
const SvgFiRrKpiEvaluation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kpi-evaluation_svg__a)">
      <path
        fill="#062147"
        d="M1.3 2.714a1 1 0 0 1 1.4-1.428l4.185 4.108a.21.21 0 0 0 .296.007l3.72-3.721a2.193 2.193 0 0 1 3.1 0l2.228 2.229a.2.2 0 0 0 .28 0l3.8-3.632a1 1 0 1 1 1.382 1.445l-3.785 3.616c-.84.842-2.235.842-3.09-.016l-2.229-2.23a.195.195 0 0 0-.272 0l-3.72 3.722c-.43.43-.994.644-1.559.644a2.2 2.2 0 0 1-1.558-.643zM6 11v2a1 1 0 1 0 2 0v-2a1 1 0 1 0-2 0M2 7a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1m11 6V8a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0m5 0v-3a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0m4-8a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1m-5.913 13.758c-.13 1.3-1.322 2.242-2.63 2.242H13.1v2.2a.8.8 0 1 1-1.6 0v-6.4a.8.8 0 0 1 .8-.8h1.3a2.5 2.5 0 0 1 2.487 2.758m-1.509-.258c0-.551-.449-1-1-1h-.555v2h.555c.551 0 1-.45 1-1m3.223-2.5a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0v-6.4a.8.8 0 0 0-.8-.8m-9.234 3.435 1.25-2.22a.815.815 0 0 0-1.413-.813l-1.449 2.465h-.354V16.8a.8.8 0 1 0-1.6 0v6.4a.8.8 0 1 0 1.6 0v-2.733h.612l1.378 3.057a.808.808 0 0 0 1.478-.656z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kpi-evaluation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKpiEvaluation;
